<template>
  <div class="divSwitch d-flex justify-content-center">
    <div class="input-switch" v-for="(item, key) in items" :key="key" @click="set(item)" :class="getClasses(item.id)">
      {{item.name}}
    </div>
  </div>
</template>

<script>
export default {
  name: 'InputSwitch',
  props: {
    name: {
      type: String,
      default: () => ''
    },
    unclickable: {
      type: Boolean,
      default: () => false
    },
    handler: {
      type: String,
      default: () => null
    },
    groupIndex: {
      type: Number,
      default: () => null
    },
    index: {
      type: Number,
      default: () => null
    },
    items: {
      type: Array,
      default: () => []
    },
    currentValue: {
      type: Boolean,
      default: () => true
    }
  },
  methods: {
    set(item) {
      const { name, groupIndex, index, handler, unclickable } = this
      !unclickable && this.$emit('set', { name, item, groupIndex, index, handler })
    },
    getClasses(id) {
      const { unclickable } = this
      const classes = []
      id === this.currentValue && classes.push('active')
      unclickable && classes.push('unclickable')
      return classes.join(' ')
    }
  }
}
</script>

<style lang="scss">

.divSwitch{
  width: 150px;
  height: auto;
  &:before{
    content: '';
    display: block;
    background-color: #2D9CDB;
    position: absolute;
    width: 100%;
    height: 2px;
  }
}
.labelSwitch {
  position: absolute;
  z-index: 1;
  left: 5px;
}
.input-switch{
  z-index: 9;
  display: flex;
  justify-content: space-around;
  height: 26px;
  cursor: pointer;
  border: 1px #2D9CDB solid;
  border-radius: 13px;
  height: 25px;
  display: flex;
  background: #fff;
  color: #2D9CDB;
  &:last-child{
    border-radius: 0 13px 13px 0;
  }
  &:first-child{
    border-radius: 13px 0px 0 13px
  }
 }
 .unclickable {
   filter: grayscale(100%);
 }
 .not-line:before{
   content: none;
 }
 
</style>